function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(-15.835 -.257)"
}, React.createElement("g", {
  fill: "#002A56",
  transform: "translate(18.208 14.513)"
}, React.createElement("ellipse", {
  cx: 7.444,
  cy: 7.245,
  rx: 7.329,
  ry: 7.137
}), React.createElement("ellipse", {
  cx: 44.089,
  cy: 7.245,
  rx: 7.329,
  ry: 7.137
})), React.createElement("path", {
  fill: "#009C54",
  d: "M76.955 25.326H21.987V.346h33.61a7.43 7.43 0 0 1 5.182 2.091l8.847 8.615c6.071 0 10.993 4.793 10.993 10.706 0 1.97-1.64 3.568-3.664 3.568z"
}), React.createElement("path", {
  fill: "#2DAD66",
  d: "M69.625 14.62h7.329c2.024 0 3.664 1.598 3.664 3.568 0 1.971-1.64 3.57-3.664 3.57h-7.329c-2.024 0-3.664-1.599-3.664-3.57 0-1.97 1.64-3.568 3.664-3.568z"
}), React.createElement("path", {
  fill: "#21B950",
  d: "M54.968 11.052h-3.665l-8.846-8.615a7.431 7.431 0 0 0-5.183-2.09H16.317c-3.262 0-6.245 1.795-7.704 4.636a8.506 8.506 0 0 1-3.852 3.75C1.843 10.156 0 13.06 0 16.237v5.522c0 1.97 1.64 3.568 3.664 3.568h58.633c2.024 0 3.664-1.597 3.664-3.568 0-5.913-4.921-10.706-10.993-10.706z"
}), React.createElement("g", {
  fill: "#00963F"
}, React.createElement("path", {
  d: "M16.491 21.758h3.664c1.012 0 1.833.798 1.833 1.784 0 .985-.82 1.784-1.833 1.784h-3.664c-1.012 0-1.832-.799-1.832-1.784 0-.986.82-1.784 1.832-1.784zM27.485 3.915c1.012 0 1.832.799 1.832 1.784V23.54c0 .986-.82 1.784-1.833 1.784-1.012 0-1.832-.798-1.832-1.784V5.7c0-.985.82-1.784 1.833-1.784z"
})), React.createElement("path", {
  fill: "#51C876",
  d: "M31.148 3.915c1.012 0 1.833.799 1.833 1.784v14.274c0 .986-.82 1.785-1.833 1.785-1.012 0-1.832-.8-1.832-1.785V5.7c0-.985.82-1.784 1.832-1.784z"
}), React.createElement("path", {
  fill: "#5ACB7D",
  d: "M38.478 11.052h18.323c1.012 0 1.832.8 1.832 1.784 0 .986-.82 1.785-1.832 1.785H38.478c-1.012 0-1.832-.8-1.832-1.785 0-.985.82-1.784 1.832-1.784z"
}), React.createElement("ellipse", {
  cx: 47.639,
  cy: 21.758,
  fill: "#0F3860",
  rx: 7.329,
  ry: 7.137
}), React.createElement("ellipse", {
  cx: 47.639,
  cy: 21.758,
  fill: "#BECAD4",
  rx: 3.664,
  ry: 3.568
}), React.createElement("ellipse", {
  cx: 10.993,
  cy: 21.758,
  fill: "#0F3860",
  rx: 7.329,
  ry: 7.137
}), React.createElement("path", {
  fill: "#0F3860",
  d: "M51.303 11.052h18.323l-7.33-7.137H43.975z"
}), React.createElement("path", {
  fill: "#345779",
  d: "M51.303 11.052H36.645c-2.024 0-3.664-1.597-3.664-3.568s1.64-3.569 3.664-3.569h7.33l7.328 7.137zM14.658 3.915h7.328c2.024 0 3.665 1.597 3.665 3.568s-1.641 3.569-3.665 3.569h-7.328c-2.024 0-3.665-1.598-3.665-3.569 0-1.97 1.64-3.568 3.665-3.568z"
}), React.createElement("g", {
  fill: "#1A4269"
}, React.createElement("path", {
  d: "M21.987 3.915h-7.329c-1.012 0-1.832.8-1.832 1.785 0 .985.82 1.784 1.832 1.784h7.33c1.011 0 1.831-.799 1.831-1.784 0-.986-.82-1.785-1.832-1.785zM42.142 3.915h-3.665c-1.011 0-1.832.8-1.832 1.785 0 .985.82 1.784 1.832 1.784h3.665c1.012 0 1.832-.799 1.832-1.784 0-.986-.82-1.785-1.832-1.785z"
})), React.createElement("path", {
  fill: "#1F456A",
  d: "M62.297 11.052V9.268c0-.986-.82-1.784-1.832-1.784s-1.833.798-1.833 1.784v1.784h3.665z"
}), React.createElement("path", {
  fill: "#00963F",
  d: "M27.485 21.758h10.992c1.012 0 1.833.798 1.833 1.784 0 .985-.82 1.784-1.833 1.784H27.485c-1.012 0-1.833-.799-1.833-1.784 0-.986.82-1.784 1.833-1.784z"
}), React.createElement("path", {
  fill: "#70D28F",
  d: "M16.491.347h21.986c1.012 0 1.833.799 1.833 1.784s-.82 1.784-1.833 1.784H16.491c-1.012 0-1.832-.799-1.832-1.784S15.479.347 16.49.347z"
}), React.createElement("path", {
  fill: "#1FAD6A",
  d: "M45.806.347h10.993c1.012 0 1.832.799 1.832 1.784s-.82 1.784-1.832 1.784H45.806c-1.012 0-1.832-.799-1.832-1.784s.82-1.784 1.832-1.784z"
}), React.createElement("path", {
  fill: "#002852",
  d: "M49.472 3.915h10.993c1.011 0 1.832.799 1.832 1.784s-.82 1.784-1.832 1.784H49.472c-1.012 0-1.833-.799-1.833-1.784s.82-1.784 1.833-1.784z"
}), React.createElement("path", {
  fill: "#5ACB7D",
  d: "M16.491 11.052h3.664c1.012 0 1.833.8 1.833 1.784 0 .986-.82 1.785-1.833 1.785h-3.664c-1.012 0-1.832-.8-1.832-1.785 0-.985.82-1.784 1.832-1.784z"
}));

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 65,
    height: 29,
    viewBox: "0 0 65 29",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.dc611231.svg";
export { ForwardRef as ReactComponent };